import IncidentsCell from './styled';

export default IncidentsCell;
